import '../navigation/tab';
import './signin';
import './signup';
import './password-reset';
const Modal = require('../ui/modal');

const markup = `<db:authenticator>
	<div data-id='features'>
		<db:tab name='Sign In' data-id='signin' data-ignore='1' noroute=1>
			<db:signin data-id='content'></db:signin>
		</db:tab>
		<db:tab name='Sign Up' data-id='signup' data-ignore='1' noroute=1>
			<db:signup data-id='content'></db:signup>
		</db:tab>
		<db:tab name='Reset' data-id='passwordReset' data-ignore='1' noroute=1>
			<db:passwordreset data-id='content'></db:passwordreset>
		</db:tab>
	</div>
</db:authenticator>`;

export default DomClass(markup, function() {
	var _t = this;

	Modal.call(this);

	on(this.signin.content, 'complete').then(user => {
		on(this, 'login').fire(user);
		this.close();
	});

	on(this.signin.content, 'require-reset').then(username => {
		this.passwordReset.content.username = username;
		this.passwordReset.select();
	});

	on(this.signup.content, 'complete').then(() => {
		on(this, 'signup').fire();
		this.signin.select();
	});

	on(this.passwordReset.content, 'complete').then(() => {
		on(this, 'password-reset').fire();
		this.signin.select();
	});

	on(this, 'close').then(() => {
		this.signin.select();
	});

	this.signin.select();

	this.close();

});
